export default {
    title: 'Components/Cards/Information Card',
    // tags: ['autodocs'],
    argTypes: {
      image_src: {
        control: 'text',
        description: 'Path to the image of the team member',
      },
      image_alt: {
        control: 'text',
        description: 'Path to the image of the team member',
      },
      header_text: {
        control: 'text',
        description: 'Header text for the information card',
      },
      body_text: {
        control: 'text',
        description: 'Body text for the information card',
      },
      


      left_button_name: {
        control: 'text',
        description: 'Name of the left button',
      },
      left_button_href: {
        control: 'text',
        description: 'Href for the right button (link)',
      },
      left_button_rel: {
        control: 'text',
        description: 'Href for the right button (link)',
      },
      left_button_start_icon: {
        control: 'text',
        description: 'Button Start icon',
      },
      left_button_end_icon: {
        control: 'text',
        description: 'Button End icon',
      },
      left_button_data_fancybox: {
        control: { type: 'text' },
        description: 'GalleryOne',
      },
      left_button_target: {
        control: { type: 'text' },
        description: 'target blank',
      },
      
      right_button_name: {
        control: 'text',
        description: 'Name of the right button',
      },
      right_button_href: {
        control: 'text',
        description: 'Href for the right button (link)',
      },
      right_button_rel: {
        control: 'text',
        description: 'Href for the right button (link)',
      },
      right_button_start_icon: {
        control: 'text',
        description: 'Button Start icon',
      },
      right_button_end_icon: {
        control: 'text',
        description: 'Button End icon',
      },
      right_button_data_fancybox: {
        control: { type: 'text' },
        description: 'GalleryOne',
      },
      right_button_target: {
        control: { type: 'text' },
        description: 'target blank',
      },




      custom_class: {
        control: { type: 'text' },
        description: 'Custom class for the credit card component',
      },
      component_mode: {
        control: { type: 'check' },
        options: ['light-mode'],
        description: 'Mode of the credit card component',
      }
    },
    parameters: {
      docs: {
        description: {
          component: `
  To use the \`dda-information-card\` component, pass the following props:
  
  \`\`\`html
<dda-information-card
    image_src="https://img.freepik.com/premium-vector/traditional-arabic-man-head-icon-vector-avatar_55610-6301.jpg"
    image_alt="alternate text"
    header_text="Team"
    body_text="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    
    left_button_name="Cancel"
    left_button_href="https://example.com"
    left_button_rel=""
    left_button_start_icon=""
    left_button_end_icon=""
    left_button_data_fancybox=""
    left_button_target=""

    right_button_name="Continue"
    right_button_href="https://example.com"
    right_button_rel=""
    right_button_start_icon=""
    right_button_end_icon=""
    right_button_data_fancybox=""
    right_button_target=""

    custom_class=""
    component_mode=""
></dda-information-card>
    \`\`\`
  `,
        },
      },
    },  
  };
  
  const Template = (args) => {
    const attributes = Object.entries(args)
      .filter(([key, value]) => value !== undefined && key !== 'text')
      .map(([key, value]) => `${key}="${value}"`)
      .join(' ');
  
    return `<dda-information-card ${attributes}></dda-information-card>`;
  };
  
  export const Default = Template.bind({});
  Default.args = {
    image_src: 'https://img.freepik.com/premium-vector/traditional-arabic-man-head-icon-vector-avatar_55610-6301.jpg',
    image_alt: 'alternate text',
    header_text: "Team",
    body_text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    
    left_button_name: "Cancel",
    left_button_href: "https://example.com",
    left_button_rel: "",
    left_button_start_icon: "",
    left_button_end_icon: "",
    left_button_data_fancybox: "",
    left_button_target: "",
    
    right_button_name: "Continue",
    right_button_href: "https://example.com",
    right_button_rel: "",
    right_button_start_icon: "",
    right_button_end_icon: "",
    right_button_data_fancybox: "",
    right_button_target: "",

    custom_class: '',
    component_mode: '',
    
  };

